import React from 'react';

import { Container, Text, Icon, Anchor } from './styles.js';

import downloadIcon from './download.png';

import catalog from './Productos.pdf';

export const Download = ({props}) => {
	
	return (
		<Container>
			<Text>CATÁLOGO</Text>
			<Anchor target="_blank"  rel="noopener noreferrer" href={catalog} download='Productos'>
				<Icon src={downloadIcon} alt="A lo Venezolano"/>
			</Anchor>
		</Container>
	)
};
